import React from 'react';
import { Star, ExternalLink, Quote } from 'lucide-react';
const REVIEWS = [{
  name: 'Sarah M.',
  text: 'Tony did an excellent job replacing our RO filters. He arrived on time, explained everything clearly, and worked efficiently. The water quality is noticeably better already.'
}, {
  name: 'David R.',
  text: 'Tony and his helper were extremely careful and thorough on the installation of our brand new water softener. Goes beyond the distance and is very patient with questions.'
}, {
  name: 'Jennifer L.',
  text: "I've been using Tony and Gretis for our plumbing needs for over two years. Quick, friendly, and easy to work with. Their pricing is very fair, which I really appreciate."
}];
export function Reviews() {
  return <section id="reviews" className="w-full bg-slate-50" data-id="element-127" data-mp="3f0cpe9czcs7s">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6" data-id="element-128" data-mp="3f1xkc037id66">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-129" data-mp="3jyxpm8s8fbw8">
          <div className="max-w-2xl" data-id="element-130" data-mp="2rce17wgnopjr">
            <span className="text-sm font-semibold uppercase tracking-wide text-sky-600" data-id="element-131" data-mp="2rdgnts6y45tv">
              Reviews
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-132" data-mp="2mfnlja8rjvyv">
              What our customers say
            </h2>
            <p className="mt-3 text-lg text-slate-600" data-id="element-133" data-mp="2de7l9vbnxa8d">
              Real feedback from homeowners across Phoenix, Casa Grande, and Tucson.
            </p>
          </div>
          <a href="https://maps.app.goo.gl/frGAoUCYNkkPEvhX7" target="_blank" rel="noopener noreferrer" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800 transition-colors hover:bg-white/60 hover:border-sky-300" data-id="element-134" data-mp="353k6682pffe1">
            Read reviews on Google
            <ExternalLink className="h-4 w-4" data-id="element-135" data-mp="3o2ejrdqfm9sm" />
          </a>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-136" data-mp="1m5e3utuw87cc">
          {REVIEWS.map(review => <figure key={review.name} className="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-137" data-mp="1r4haujufonmy">
              <Quote className="h-7 w-7 text-sky-200" data-id="element-138" data-mp="1cf1jp2qzqg6q" />
              <div className="mt-3 flex" data-id="element-139" data-mp="1he5svtdx0dx2">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-140" data-mp="13f69b059ep7r" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-slate-600" data-id="element-141" data-mp="18f0x2utqmyol">
                {review.text}
              </blockquote>
              <figcaption className="mt-4 text-sm font-semibold text-slate-900" data-id="element-142" data-mp="titaxoyrrn6o">
                {review.name}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}